import _ from 'lodash';
import React from 'react';
import Modal from 'react-modal';

// import Beauty2024Light from 'components/Beauty2024Light';
import { useUserAuth } from 'contexts/UserAuth';

const { useState, useRef } = React;

const Beauty2025LandingModal = (props) => {
  const { show, setShow } = props;

  const close = () => {
    setShow(false);
  };

  return (
    <Modal
      isOpen={show}
      onRequestClose={close}
      shouldCloseOnOverlayClick={false}
      className="relative h-full max-h-none w-full overflow-y-auto rounded-none bg-white outline-none p-safe-offset-0 lg:h-auto lg:max-h-[80vh] lg:w-[480px] lg:rounded-lg"
      style={{
        content: {
          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 24px 48px',
          background:
            'linear-gradient(206deg, var(--Light-pink, #FFE5E9) 35.86%, rgba(235, 89, 148, 0.50) 73.84%)',
        },
      }}
      overlayClassName="z-[70] absolute flex items-center justify-center top-0 left-0 right-0 bottom-0 w-full h-full bg-white"
    >
      <div className="relative flex h-full w-full flex-col items-center justify-center lg:h-[670px]">
        <div className="relative flex flex-col items-center justify-center rounded-2xl bg-white px-6 py-8">
          <img
            src="/svgs/complete-gift.svg"
            className="mx-auto h-[150px] w-[150px] object-contain lg:h-32 lg:w-32"
          />
          <div className="mt-6 text-center text-xl font-bold text-[#111928]">
            🎉 恭喜成為SORRA會員
          </div>
          <div className="mt-2 text-center text-base text-[#111928]">
            感謝您參與SORRA年度票選，立即抽獎！
          </div>
          <button
            className="mt-6 flex h-12 w-full items-center justify-center rounded-full bg-sorra-pink px-5 py-3 lg:w-[311px]"
            onClick={() => {
              setShow(false);
            }}
          >
            <p className="text-base text-white">立即開始抽獎</p>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default Beauty2025LandingModal;
